import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { type Dictionary, type TNews } from '~/types';
import { newsAPI } from '~/api';

const getAll = createAsyncThunk('news/getAll', async (amount?: number) => {
  return newsAPI.getAll(amount);
});

export type NewsState = {
  loading: boolean;
  items: number[];
  map: Dictionary<TNews>;
};

const initialState: NewsState = {
  loading: true,
  items: [],
  map: {},
};

export const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAll.fulfilled, (state, action) => {
      for (const news of action.payload) {
        if (!state.map[news.id]) {
          state.items.push(news.id);
        }
        state.map[news.id] = news;
      }
      state.loading = false;
    });
  },
  selectors: {
    news: (state) => state.items.map((id) => state.map[id]),
  },
});

export const {
  actions: newsActions,
  reducer: newsReducer,
  selectors: newsSelectors,
} = newsSlice;

export const newsThunks = {
  getAll,
};
